import { useMemo } from 'react';

import { mapSchemaToSelect } from 'app/Content/Rules/EditRule/SchemaFieldSelect/mapper';

import { useRecordSchema } from './useRecordSchema';

export const useRecordFields = () => {
  const { data, loading } = useRecordSchema();
  const recordSchema = data && JSON.parse(data.recordSchema);

  const recordFields = useMemo(
    () => (recordSchema ? mapSchemaToSelect(recordSchema) : []),
    [recordSchema]
  );

  return {
    recordFields,
    loading,
  };
};
